/**
 * Читалка статей поверх карты — маленькое общее состояние без контекста.
 *
 * Ссылка-заголовок расшифровки («Венера в Овне») — настоящий <a href> для
 * робота, а клик человека открывает статью здесь же, панелью: карта, попап и
 * расчёт на странице остаются. Хозяин панели (ArticleReaderHost) один на
 * приложение; пока он не смонтирован, ссылка работает обычным переходом.
 *
 * sequence — заголовки карты со ссылками по порядку расшифровки
 * ([{ label, link }]): из них читалка берёт строку «Дальше: …».
 */
let state = { link: null, label: '' };
let sequence = [];
let hosts = 0;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(state));

export const getArticleReaderState = () => state;

export function subscribeArticleReader(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/** Хозяин панели смонтирован — клик можно перехватывать. */
export function registerArticleReaderHost() {
  hosts += 1;
  return () => { hosts -= 1; };
}
export const articleReaderAvailable = () => hosts > 0;

export function openArticle(link, label = '') {
  if (!link || !link.url) return;
  state = { link, label: label || link.title || '' };
  emit();
}

export function closeArticle() {
  if (!state.link) return;
  state = { link: null, label: '' };
  emit();
}

export function setArticleSequence(items) {
  sequence = Array.isArray(items) ? items : [];
}

const sameTarget = (a, b) => a.url === b.url && (a.house || null) === (b.house || null);

/** Следующий заголовок карты после открытой статьи (link) — с другой
 *  статьёй или другим разделом той же статьи («в знаке в домах» → дом). */
export function nextArticleAfter(link) {
  const cur = typeof link === 'string' ? { url: link } : link;
  const i = sequence.findIndex((it) => sameTarget(it.link, cur));
  const from = i >= 0 ? i : sequence.findIndex((it) => it.link.url === cur.url);
  if (from < 0) return null;
  return sequence.slice(from + 1).find((it) => !sameTarget(it.link, cur)) || null;
}

/** Раздел дома в тексте статьи: заголовок с якорем «…N-dom…», иначе первый
 *  заголовок со словами «N дом» («в 12 доме», «12-й дом»). */
export function findHouseHeading(root, n) {
  if (!root || !n) return null;
  const heads = [...root.querySelectorAll('h1, h2, h3, h4, h5')];
  const idRe = new RegExp(`(^|[^0-9])${n}-(y-|i-|om-|m-)?dom`, 'i');
  const byId = heads.find((h) => h.id && idRe.test(h.id));
  if (byId) return byId;
  const textRe = new RegExp(`(^|[^0-9])${n}(\\s*-?\\s*(й|м|ом|ый))?\\s+дом`, 'i');
  return heads.find((h) => textRe.test(h.textContent || '')) || null;
}
